export default {
  // 获取抽奖详细
  findOneDrawRaffleById: '/amc/client/findOneDrawRaffleById',
  // 根据抽奖id 获得抽奖下面的所有奖项
  listAwardByDrawRaffleId: '/amc/client/listAwardByDrawRaffleId',
  // 获取剩余抽奖次数
  getDrawRaffleTimes: '/amc/client/getDrawRaffleTimes',
  // 抽奖(定时抽奖，即时抽奖)
  doDrawRaffle: '/amc/client/doDrawRaffle',
  // 获得我的及时抽奖中奖奖品
  listAwardLogsByMemberId: '/amc/client/listAwardLogsByMemberId',
  // 兑奖
  acceptPrize: '/amc/client/acceptPrize',
  // 保存奖品邮寄地址
  awardSaveExpressInfo: '/amc/client/awardSaveExpressInfo',
}